(() => {
  let debounceTimer;

  const qtyButtons = document.querySelectorAll(
    ".displayQtySelectors .js-qty__adjust"
  );

  qtyButtons.forEach((btn) => btn.addEventListener("click", clickHandler));

  function clickHandler(event) {
    clearTimeout(debounceTimer);

    const input = event.currentTarget.closest(".js-qty").querySelector("input");

    debounceTimer = setTimeout(() => {
      updateQty(input);
    }, 500);
  }

  function updateQty(input) {
    const initialQty = Number(input.dataset.qty);
    const qty = Number(input.value);
    const id = input.dataset.id;

    if (initialQty === qty) return;

    fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        quantity: qty,
      }),
    }).then((res) => (window.location.href = location.href));
  }
})();
